import { useContext } from 'react';
import cx from 'classnames';
import { TrialFlag } from 'core/components/TrialFlag';
import StudentPendingActivationModal from 'edrolo/components/StudentPendingActivationModal';
import { StudentNames } from './components/StudentNames';
import { Container, Heading, utils as u } from 'edrolo-ui';
import { SchoolClassType } from 'edrolo/enums/SchoolClassType';
import { ClassContext } from 'edrolo/context';
import { Skeleton } from './Skeleton';
import s from './styles.scss';

const CourseHeader = () => {
  const {
    data: { isTeacherView, classDetail, classId, assemblage },
  } = useContext(ClassContext);

  const students = Object.values(classDetail.students || {}) || [];
  const studentNamesList = students
    .filter((student) => !student.is_active)
    .map((student) => student.display_name);

  const isTrial =
    classDetail.class_type === SchoolClassType.STUDENT_TRIAL ||
    classDetail.class_type === SchoolClassType.TEACHER_TRIAL;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const staticUrl: string = (global as any).__static__ || '/static';

  return (
    <header
      className={s.courseHeader}
      data-appcues="course-header"
      style={{
        backgroundImage: `url("${staticUrl}img/hero-banner-texture-min.png")`,
      }}
      data-test="course-header"
    >
      <img src={assemblage.course.thumbnail_url} className={s.thumbnail} />

      <Container>
        <div className={s.contentWrapper}>
          {isTeacherView && (
            <div className={cx(u.flex, u.gap2)}>
              <Heading level={4} className={u.primary6}>
                {classDetail.title}
              </Heading>
              {isTrial && (
                <TrialFlag expirationDate={classDetail.expiration_date} />
              )}
            </div>
          )}

          <Heading.Display level={1}>{assemblage.course.title}</Heading.Display>
          {isTeacherView && (
            <>
              <StudentNames students={students} classId={classId} />
              <StudentPendingActivationModal
                studentNamesList={studentNamesList}
                activationLink={classDetail.activation_link}
              />
            </>
          )}
        </div>
      </Container>
    </header>
  );
};

CourseHeader.Skeleton = Skeleton;

export { CourseHeader };
